
export default {
  name: "SwitchCell",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      if (!this.loading)
        this.$emit("onEvent", {
          type: "switch",
          value: !this.active,
          sublevel: this.$attrs.sublevel,
        });
    },
  },
};
